import { createActions } from 'redux-actions'

export const { onBoarding } = createActions({
  ON_BOARDING: {
    /** Handled by saga: @see store/entities/onBoarding/saga/changeProTrack */
    CHANGE_PRO_TRACK: proTrackLevelId => ({ proTrackLevelId }),
    /** Handled by saga: @see store/entities/onBoarding/saga/savePreferences */
    SAVE_PREFERENCES: values => ({ values }),
    CHANGE_IS_LOADING: isLoading => ({ isLoading }),
  },
})
